import { AiOutlineCheckCircle } from "react-icons/ai";
import {useEffect} from "react";
import AOS from "aos";
export default function Component() {
  return (
    <div className="relative -mt-12 bg-white mx-4 min-h-[500px]">
      <div className="size-4/12 mx-auto md:mx-0 md:relative w-[100%]">
        <div className="flex flex-row items-center justify-between py-12 min-h-[500px]">
          <div className="lg:flex-1 z-20 absolute right-[35px]">
            <div className=" bg-white p-12 rounded-lg shadow-lg"
                 data-aos="fade-left"
            >
              <h5 className="text-4xl font-bold mb-8 text-gray-800">
                Rent A <br /> Car Today
              </h5>
              <div className="text-gray-600">
                <div className="flex items-center mb-2">
                  <AiOutlineCheckCircle className="text-red-500 mr-2 text-3xl" />
                  <span>Drive</span>
                </div>
                <div className="flex items-center mb-2">
                  <AiOutlineCheckCircle className="text-red-500 mr-2 text-3xl" />
                  <span>Connect</span>
                </div>
                <div className="flex items-center mb-2">
                  <AiOutlineCheckCircle className="text-red-500 mr-2 text-3xl" />
                  <span>Laugh</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img
        alt="Happy people in a car"
        className=" absolute inset-0 w-full h-full object-cover min-h-[500px]"
        src="image/home/image9.jpg"
      />
    </div>
  );
}
